import React from 'react';
import { Popup as MapGLPopup, PopupProps } from 'react-map-gl';
import { cn } from '@core/utils/cn';
import { FacilityDto } from '../../../core/api/StudioClient';

export const Popup = ({ className, ...props }: PopupProps) => (
    <MapGLPopup {...props} className={cn('z-[3]', className)} />
);

interface NearbyFacilityInfoProps {
    facility: FacilityDto;
}

export const NearbyFacilityInfo = ({ facility }: NearbyFacilityInfoProps) => (
    <div className="grid min-w-[300px] grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-black">
        <span className="text-sm font-semibold">Name:</span>
        <span className="text-sm">{facility.name}</span>
        <span className="text-sm font-semibold">Address:</span>
        <span className="text-sm">
            {facility.address.street} {facility.address.houseNumber}
        </span>
    </div>
);
